export const heroData = {
  title: "How to Book",
  subtitle: "Booking is easy through our online inquiry form. Our dedicated staff will suggest the best plan for your needs.",
  image:
    "https://readdy.ai/api/search-image?query=Modern%20office%20desk%20with%20laptop%20showing%20travel%20booking%20website%2C%20warm%20ambient%20lighting%2C%20elegant%20workspace%20with%20notebook%20and%20coffee%2C%20professional%20consultation%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=bookhero01&orientation=landscape",
};

export const stepsData = {
  label: "STEP",
  title: "From Booking to Boarding",
  steps: [
    {
      num: "01",
      title: "Submit an Inquiry Online",
      desc: "Enter your preferred date, time, and number of guests, then submit. Available 24 hours a day.",
      details: ["Response within the next business day", "Compare multiple plans", "Flexible date adjustments"],
    },
    {
      num: "02",
      title: "Receive a Proposal from Our Staff",
      desc: "Based on your inquiry, we will suggest the best plan and check availability. Any questions can be resolved at this stage.",
      details: ["Personalized plan comparison", "Option guidance", "Payment method confirmation"],
    },
    {
      num: "03",
      title: "Confirm Your Booking",
      desc: "Once you have chosen your plan, we will confirm your reservation and send payment instructions.",
      details: ["Booking confirmation issued", "Payment instructions sent", "Access information provided"],
    },
    {
      num: "04",
      title: "Pre-Departure Guide",
      desc: "Before your flight, we will send detailed guidance on attire, what to bring, the day-of schedule, and access information.",
      details: ["Attire guide", "Packing checklist", "Helipad access guide"],
    },
    {
      num: "05",
      title: "Board on the Day",
      desc: "Arrive at the helipad, check in, and board. Your special experience begins.",
      details: ["Check-in & safety briefing", "Pilot introduction", "Commemorative photo (optional)"],
    },
  ],
};

export const finalCTA = {
  title: "Feel free to reach\nout anytime",
  subtitle: "Our dedicated staff will carefully listen to your needs",
  ctas: [
    { label: "Inquire About Booking", href: "/contact", type: "primary" },
    { label: "View Pricing & Plans", href: "/pricing", type: "secondary" },
  ],
};
